var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ active: _vm.active },style:({ 'margin': '1px' }),on:{"click":_vm.thisComponentClick}},[_c('div',{staticClass:"header",style:({ 'background-color': _vm.penProps.lineColor, 'width': '20px', height: '20px' })}),_vm._v("\n  "+_vm._s(_vm.penProps.name)+"\n  "+_vm._s(_vm.penProps.lineWidth)+"px\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0480586d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/canvas/controller/penProperty-penSelector.vue
// module id = null
// module chunks = 